import { css } from '@emotion/react';

export const useStyles = (props) => ({
  chartWrapper: css({
    position: "relative",
  }),
  noChartWrapper: css({
    position: "absolute",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
  }),
  noChartIcon: css({
    fontSize: "90px !important",
    width: "90px !important",
    height: "90px !important",
    color: "white !important",
    "& svg": {
      color: "white !important",
    },
  }),
  noChartContent: css({
    color: "white",
    textAlign: "center",
    marginTop: "20px",
    fontSize: "16px",
    fontWeight: 500,
  }),
  noChartContentSmall: css({
    color: "white",
    textAlign: "center",
    marginTop: "10px",
    fontSize: "12px",
  }),
});
